import { formatPhoneNumber, getGender } from "../helpers/string-format-helper";

export const getFormDataManagementStudent = (
  classrooms: Classroom[],
  classroomId?: number,
  student?: Student
) => {
  const newStudentFormData: FormParams = {
    items: {
      upperFields: [
        {
          element: 'title',
          value: 'Sobre o aluno',
        },
        {
          element: 'input',
          type: 'text',
          id: 'studentName',
          placeHolder: 'nome do aluno',
          label: 'Nome',
          defaultValue: student ? student.name : null,
        },
        {
          element: 'select',
          id: 'studentClassroom',
          label: 'Turma',
          defaultValue: classroomId
            ? classroomId
            : student
              ? student.classroomId
              : null,
          options: classrooms.map((classroom) => {
            return { value: classroom.id, text: classroom.name };
          }),
        },
        {
          element: 'select',
          id: 'studentGender',
          label: 'Gênero',
          defaultValue: student ? student.gender : null,
          options: [
            { value: 'Male', text: getGender('Male') },
            { value: 'Female', text: getGender('Female') },
            { value: 'NotInformed', text: getGender('NotInformed') },
          ],
        },
      ],
    },
    style: 'gray',
  };

  const newResponsibleFormData: FormParams = {
    items: {
      upperFields: [
        {
          element: 'title',
          value: 'Sobre os responsáveis',
        },
        {
          element: 'responsible',
          inputs: [
            {
              subtitle: {
                element: 'subtitle',
                value: 'Primeiro responsável',
              },
              name: {
                element: 'input',
                type: 'text',
                id: 'firstResponsibleName',
                placeHolder: 'nome do responsável',
                label: 'Nome',
                defaultValue:
                  student && student.responsibles.length > 0
                    ? student.responsibles[0].name
                    : null,
              },
              phone: {
                element: 'input',
                type: 'text',
                id: 'firstResponsiblePhone',
                placeHolder: 'celular do responsável',
                label: 'Celular',
                defaultValue:
                  student && student.responsibles.length > 0
                    ? formatPhoneNumber(student.responsibles[0].phone)
                    : null,
              },
              email: {
                element: 'input',
                type: 'email',
                id: 'firstResponsibleEmail',
                placeHolder: 'email do responsável',
                label: 'Email',
                defaultValue:
                  student && student.responsibles.length > 0
                    ? student.responsibles[0].email
                    : null,
              },
            },
            {
              subtitle: {
                element: 'subtitle',
                value: 'Segundo responsável',
              },
              name: {
                element: 'input',
                type: 'text',
                id: 'secondResponsibleName',
                placeHolder: 'nome do responsável',
                label: 'Nome',
                defaultValue:
                  student && student.responsibles.length > 1
                    ? student.responsibles[1].name
                    : null,
              },
              phone: {
                element: 'input',
                type: 'text',
                id: 'secondResponsiblePhone',
                placeHolder: 'celular do responsável',
                label: 'Celular',
                defaultValue:
                  student && student.responsibles.length > 1
                    ? formatPhoneNumber(student.responsibles[1].phone)
                    : null,
              },
              email: {
                element: 'input',
                type: 'email',
                id: 'secondResponsibleEmail',
                placeHolder: 'email do responsável',
                label: 'Email',
                defaultValue:
                  student && student.responsibles.length > 1
                    ? student.responsibles[1].email
                    : null,
              },
            },
          ],
        },
      ],
    },
    style: 'gray',
  };

  return [
    newStudentFormData,
    newResponsibleFormData
  ]
};